import { axios } from '../utilities';

const getPackageByCustomerId = userId => axios.get(`api/users/${userId}/package`);

const getPackageForProofByProjectId = projectId => axios.get(`api/projects/${projectId}/package-for-proof`);

const getDataForUpgradesByProjectId = projectId => axios.get(`api/packages/${projectId}/data-to-upgrade`);

const upgradePackageRequest = (projectId, orders) => (
  axios.put('api/packages/request-to-upgrade', { orders, projectId })
);

const revertUpgradeRequest = (projectId, upgradeRequestId) => axios.post('api/packages/revert-upgrade-request', { projectId, upgradeRequestId });

const requestExtensionFeePayment = () => axios.put('api/packages/request-extension-fee-payment');

export default {
  getPackageByCustomerId,
  getPackageForProofByProjectId,
  getDataForUpgradesByProjectId,
  upgradePackageRequest,
  revertUpgradeRequest,
  requestExtensionFeePayment,
};
